import User from 'records/User';

interface Fullstory {
  identify(userId: any, userData: any);
}

// Add Fullstory to window.
declare global {
  interface Window {
    FS: Fullstory;
  }
}

export function initializeFullstory(user: User) {
  if (!user) return;

  if (!window.FS.identify) {
    return console.error("Tried to initialize Fullstory, but it isn't available yet");
  }
  window.FS.identify(user.id, {
    accountId: user.accountId,
    accountName: user.accountName,
    displayName: user.displayName,
    email: user.email,
    isManager: user.isManager(),
    isAdmin: user.isAdmin(),
    isCoach: user.isCoach,
  });
}
